<template>
  <div class="pd1-flow">
    <van-steps
      direction="vertical"
      :active="active"
    >
      <van-step
        v-for="(flow, index) in flowList"
        :key="index"
      >
        <div class="pd1-flow-item">
          <div class="pd1-flow-item-left">
            <h3>{{ index + 1 }}、{{ flow.title }}</h3>
            <p>{{ flow.des }}</p>
          </div>
          <div class="pd1-flow-item-right">
            <el-link
              :underline="false"
              v-if="flow.perfectBtnShow"
              @click="perfect(flow)"
            >
              点击完善<i class="el-icon-arrow-right el-icon--right"></i>
            </el-link>
          </div>
        </div>
      </van-step>

    </van-steps>
    <van-popup
      v-model="meansShow"
      round
    >
      <div class="association">
        <div class="association-title">专家安排</div>
        <van-form label-width="70px">
          <van-field
            name="checkbox"
            label="服务状态:"
          >
            <template #input>
              <van-checkbox
                v-model="meansForm.status"
                shape="square"
                name="2"
              > 专家已安排 </van-checkbox>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            v-model="meansForm.service_type_name"
            name="服务名称"
            label="服务名称:"
            placeholder="服务名称"
            @click="showServiceNamePicker = true"
            :rules="[{ required: true, message: '请填写服务名称' }]"
          />
          <van-popup
            get-container="body"
            v-model="showServiceNamePicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              value-key="name"
              :columns="serviceNameColumns"
              @cancel="showServiceNamePicker = false"
              @confirm="serviceConfirm"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="meansForm.diagnose_time"
            label="时间选择"
            placeholder="点击选择时间"
            @click="showTimePicker = true"
          />
          <van-popup
            get-container="body"
            v-model="showTimePicker"
            position="bottom"
          >
            <van-datetime-picker
              type="datehour"
              ref="datehourPicker"
              title="选择日期时间段"
              :min-date="dateForm.minDate"
              :max-date="dateForm.maxDate"
              :format="dateForm.dateFormat"
              :filter="dateFilter"
              @cancel="showTimePicker = false"
              @confirm="timeConfirm"
            />
          </van-popup>
          <van-field
            v-model="meansForm.diagnose_expert"
            name="看诊专家"
            label="看诊专家:"
            placeholder="看诊专家"
            :rules="[{ required: true, message: '请填写看诊专家' }]"
          />
          <van-field
            name="radio"
            label="看诊方式:"
          >
            <template #input>
              <van-radio-group
                v-model="meansForm.diagnose_type"
                direction="horizontal"
              >
                <van-radio
                  v-for="item in pd1EnumsMap.diagnose_typeArr"
                  :key="item.value"
                  :name="item.value"
                >{{ item.name }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

        </van-form>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="meansShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="editProgressExpertStep2"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="dataReviewShow"
      round
    >
      <div class="association">
        <div class="association-title">资料审核</div>
        <van-form label-width="90px">
          <van-field
            readonly
            clickable
            v-model="dataReviewForm.certi_status_name"
            name="资料审核状态"
            label="资料审核状态:"
            placeholder="资料审核状态"
            @click="showAuditStatusPicker = true"
            :rules="[{ required: true, message: '请选择资料审核状态' }]"
          />
          <van-popup
            get-container="body"
            v-model="showAuditStatusPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              value-key="name"
              :columns="auditStatusColumns"
              @cancel="showAuditStatusPicker = false"
              @confirm="auditStatusConfirm"
            />
          </van-popup>
          <van-field
            v-model="dataReviewForm.reject_reason"
            type="textarea"
            rows="3"
            name="原因"
            label="原因:"
            placeholder="原因"
            :rules="[{ required: true, message: '请填写原因' }]"
          />

        </van-form>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="dataReviewShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="progressButieStep2"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="subsidyShow"
      round
    >
      <div class="association">
        <div class="association-title">补贴进度</div>
        <van-form label-width="70px">
          <van-field
            name="radio"
            label="补贴进度:"
          >
            <template #input>
              <van-radio-group
                v-model="subsidyForm.status"
                direction="horizontal"
              >
                <van-radio
                  v-for="item in pd1EnumsMap.bonus_statusArr"
                  :name="item.value"
                  :key="item.value"
                >{{ item.name }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="subsidyForm.content"
            type="textarea"
            rows="3"
            name="补贴内容"
            label="补贴内容:"
            placeholder="补贴内容"
            :rules="[{ required: true, message: '请填写补贴内容' }]"
          />

        </van-form>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="subsidyShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="progressButieStep3"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="visitingArrangementsShow"
      round
    >
      <div class="association">
        <div class="association-title">看诊安排</div>
        <van-form label-width="70px">
          <van-field
            name="checkbox"
            label="看诊状态:"
          >
            <template #input>
              <van-checkbox
                v-model="visitingArrangementsForm.service_type"
                name="2"
                shape="square"
              > 已看诊 </van-checkbox>
            </template>
          </van-field>

        </van-form>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="visitingArrangementsShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="editProgressExpertStep3"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="medicationArrangementsShow"
      round
    >
      <div class="association">
        <div class="association-title">购药安排</div>
        <van-form label-width="70px">
          <van-field
            name="radio"
            label="购药安排:"
          >
            <template #input>
              <van-radio-group
                v-model="medicationArrangementsForm.radio"
                direction="horizontal"
              >
                <!-- <van-radio
                  v-for="item in pd1EnumsMap.medicine_statusArr"
                  :key="item.value"
                  :name="item.value"
                >{{ item.name }}</van-radio> -->
                <van-radio name="2">已安排</van-radio>
              </van-radio-group>
            </template>
          </van-field>

        </van-form>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="medicationArrangementsShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="progressGouyaoStep2"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pd1Service from "@/apis/pd1/index.js";
import enums from "@/views/pd1/mixins/enums";
import moment from "moment";
import { Toast } from "vant";

export default {
  data() {
    return {
      active: "1",

      medicationArrangementsShow: false,
      medicationArrangementsForm: {},

      visitingArrangementsShow: false,
      visitingArrangementsForm: {},

      subsidyShow: false,
      subsidyForm: {},

      dataReviewShow: false,
      dataReviewForm: {},
      showAuditStatusPicker: false,
      auditStatusColumns: [],

      meansShow: false,
      meansForm: {},
      showTimePicker: false,
      dateForm: {
        minDate: new Date(moment().add(1, "hour").format("YYYY-MM-DD HH:mm")),
        maxDate: new Date(new Date().getFullYear() + 1, 11, 31),
        dateFormat: "YYYY-MM-DD HH:mm",
        minHour: 9,
        maxHour: 18,
        minMinute: 0,
        maxMinute: 30,
      },
      showServiceNamePicker: false,
      serviceNameColumns: [],
      flowList: [
        //         {
        //           title: "任务受理",
        //           des: "已受理",
        //         },
        //         {
        //           title: "专家安排",
        //           des: `服务名称：圆和专家看诊
        // 看诊专家：张伞伞
        // 看诊时间：2023-05-05 09:00-09:30
        // 看诊方式：线上看诊
        //           `,
        //           perfectBtnShow: true,
        //           type: "means",
        //         },
        //         {
        //           title: "资料审核",
        //           des: "已受理1",
        //           perfectBtnShow: true,
        //           type: "dataReview",
        //         },
        //         {
        //           title: "补贴进度",
        //           des: "",
        //           perfectBtnShow: true,
        //           type: "subsidy",
        //         },
        //         {
        //           title: "看诊安排",
        //           des: "",
        //           perfectBtnShow: true,
        //           type: "visitingArrangements",
        //         },
        //         {
        //           title: "购药安排",
        //           des: "",
        //           perfectBtnShow: true,
        //           type: "medicationArrangements",
        //         },
      ],
    };
  },
  mixins: [enums],

  created() {
    this.getProgress();
  },
  methods: {
    init() {
      const { pd1EnumsMap } = this;
      const service_type = this.$route.query.service_type;
      this.serviceNameColumns = pd1EnumsMap.expert_service_typeArr.filter(
        (item) => {
          return item.value.toString().startsWith(service_type);
        }
      );
      this.auditStatusColumns = pd1EnumsMap.certi_statusArr;
    },
    serviceConfirm(value) {
      const { meansForm } = this;
      meansForm.service_type_name = value.name;
      meansForm.service_type = value.value;
      this.showServiceNamePicker = false;
    },
    auditStatusConfirm(value) {
      const { dataReviewForm } = this;
      dataReviewForm.certi_status_name = value.name;
      dataReviewForm.certi_status = value.value;
      this.showAuditStatusPicker = false;
    },
    timeConfirm(value) {
      const { meansForm } = this;
      const picker = this.$refs.datehourPicker.getPicker();

      meansForm.diagnose_time = `${moment(value).format(
        "YYYY-MM-DD"
      )} ${picker.getColumnValue(3)}`;
      this.showTimePicker = false;
    },
    editProgressExpertStep2() {
      const { meansForm, currentUserInfo } = this;
      const query = this.$route.query;
      const params = {
        ...meansForm,
        status: meansForm.status ? 2 : 1,
        work_id: query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      pd1Service.editProgressExpertStep2(params).then(() => {
        this.meansShow = false;
        this.getProgress();
      });
    },
    editProgressExpertStep3() {
      const { visitingArrangementsForm, currentUserInfo } = this;
      const query = this.$route.query;
      if (!visitingArrangementsForm.service_type) {
        Toast("请选择看诊进度");
        return;
      }
      const params = {
        service_type: query.service_type,
        work_id: query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      pd1Service.editProgressExpertStep3(params).then(() => {
        this.visitingArrangementsShow = false;
        this.getProgress();
      });
    },
    progressGouyaoStep2() {
      const { medicationArrangementsForm, currentUserInfo } = this;
      const query = this.$route.query;
      if (!medicationArrangementsForm.radio) {
        Toast("请选择购药安排进度");
        return;
      }
      const params = {
        work_id: query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      pd1Service.progressGouyaoStep2(params).then(() => {
        this.medicationArrangementsShow = false;
        this.getProgress();
      });
    },
    progressButieStep2() {
      const { dataReviewForm, currentUserInfo } = this;
      const query = this.$route.query;
      let errMsg = "";
      if (!dataReviewForm.certi_status) {
        errMsg = "请选择审核状态";
      } else if (
        dataReviewForm.certi_status == 3 &&
        !dataReviewForm.reject_reason
      ) {
        errMsg = "请填写审核不通过原因";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }

      const params = {
        ...dataReviewForm,
        work_id: query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      pd1Service.progressButieStep2(params).then(() => {
        this.dataReviewShow = false;
        this.getProgress();
      });
    },
    progressButieStep3() {
      const { subsidyForm, currentUserInfo } = this;
      const query = this.$route.query;
      let errMsg = "";
      if (!subsidyForm.status) {
        errMsg = "请选择补贴进度";
      } else if (subsidyForm.status == 2 && !subsidyForm.content) {
        errMsg = "请填写补贴内容";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }
      const params = {
        ...subsidyForm,
        work_id: query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      pd1Service.progressButieStep3(params).then(() => {
        this.subsidyShow = false;
        this.getProgress();
      });
    },
    getProgress() {
      const typeMap = {
        expert_status: "means",
        diagnose_status: "visitingArrangements",
        medicine_status: "medicationArrangements",
        certi_status: "dataReview",
        bonus_status: "subsidy",
        settle_status: "settle_status",
      };
      const params = {
        work_id: this.$route.query.work_id,
      };
      pd1Service.progress(params).then((res) => {
        const steps = res.steps;
        steps.forEach((item, index) => {
          item.type = typeMap[item.name];
          if (item.status >= 1 && item.type) {
            item.perfectBtnShow = true;
          }
          if (item.status > 1) {
            this.active = index;
          }
          if (item.datas) {
            item.des = item.text;
            item.datas.forEach((dataItem) => {
              item.des = `${item.des}
${dataItem.name}: ${dataItem.value}
              `;
            });
          } else {
            item.des = item.text;
          }
        });
        this.flowList = steps;
      });
    },
    dateFilter(type, options) {
      if (type === "hour") {
        const newOptions = [];
        options.forEach((item) => {
          newOptions.push(`${item}:00-${item}:30`);
          newOptions.push(`${item}:30-${item}:59`);
        });
        options = newOptions;
      }
      return options;
    },
    perfect(flow) {
      const { type } = flow;
      if (type === "settle_status") {
        this.$router.push({
          name: "Pd1PharmacyFinder",
          query: {
            ...this.$route.query,
          },
        });
      } else {
        this[`${type}Show`] = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pd1-flow {
  .pd1-flow-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pd1-flow-item-left {
      h3 {
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
      p {
        font-size: 14px;
        color: #999;
        white-space: pre-wrap;
      }
    }
    .pd1-flow-item-right {
      font-size: 14px;
      color: #999;
      flex-shrink: 0;
    }
  }
}
.association {
  width: 325px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .association-search {
    width: 100%;
  }
  .association-radio {
    width: 100%;
    min-height: 100px;
    max-height: 350px;
    overflow-y: scroll;
    .el-radio-group {
      display: flex;
      flex-direction: column;
      padding: 0 5px;
    }
    .el-radio {
      margin: 5px 0;
    }
  }
  .association-btn {
    margin-top: 20px;
  }
}
</style>